import { defineComponent as _defineComponent } from 'vue'
import BaseDialog from "@/components/base-dialog.vue";
import FileIcon from "@/assets/icons/svg/file.icon.svg";


export default /*#__PURE__*/_defineComponent({
  __name: 'online-answersheet-info-dialog',
  props: {
    isVisible: { type: Boolean },
    onClose: null
  },
  setup(__props: any) {

const props = __props as {
  isVisible: boolean;
  onClose: () => void;
}



const closeDialog = () => {
  props.onClose();
};

return { __sfc: true,props, closeDialog, BaseDialog, FileIcon }
}

})